export default class ApiService {

    static get $inject() {
        return [
            '$q', '$http', '$state',
            'ApiService'
        ];
    }

    constructor($q, $http, $state,
                ApiService) {

        this._api = ApiService.api;
        this.$q = $q;
        this.$http = $http;
        this.$state = $state;

        if (this.panelsCounter === undefined) {
            this.panels().then(panels => {
                this.setPanelsCounter(panels.count);
            })
        }
    }

    getPanelUsersByPanelId(panelId) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/panel_users/`,
            method: 'GET'
        });

    }

    deleteCloudPanelUser(panelId, userId) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/panel_users/${userId}/`,
            method: 'DELETE'
        });

    }

    setPanelName(userId, panelName, mac) {

        return this.$http({
            url: `${this._api}/panel_users/${userId}/`,
            method: 'PUT',
            data: {
                'name': panelName,
                'user_code': this.getUserCode(),
                'control_panel': {
                    'mac': mac,
                    'remote_access_password': this.getRemoteAccessPassword(),
                }
            }
        });
    }

    setPanelNotifications(mac, panelName, userId, notificationFilterObject, receivePicturesBoolean, notificationLanguage) {

        return this.$http({
            url: `${this._api}/panel_users/${userId}/`,
            method: 'PUT',
            data: {
                'name': panelName,
                'user_code': this.getUserCode(),
                'notifications_filter': notificationFilterObject,
                'receive_pictures': receivePicturesBoolean,
                'control_panel': {
                    'mac': mac,
                    'remote_access_password': this.getRemoteAccessPassword(),
                },
                'notification_language': notificationLanguage
            }
        });
    }

    setSpecificEmailNotification(panelId, paramObject, notificationId = null) {
        let url = `${this._api}/panels/${panelId}/notifications/`;
        if (notificationId) {
            url += `${notificationId}/`;
            return this.$http.put(url, paramObject);
        }
        return this.$http.post(url, paramObject);

    }

    panels(page = 1, searchText = '') {

        return this.$http.get(this._api + `/panel_users/?page=${page}&search=${searchText}`)
            .then(r => {
                this.setPanelsCounter(r.data.count);
                return r.data;
            })
            .catch(r => {
                return {};
            });
    }

    getPanelById(panelId) {

        return this.$http.get(this._api + '/panel_users/' + panelId + '/')
            .then(resp => {
                return resp;
            })
            .catch(() => {
                return {};
            });
    }

    create(data) {
        return this.$http.post(`${this._api}/panel_users/`, data);
    }

    update(panelId, data) {
        return this.$http({
            url: `${this._api}/panel_users/${panelId}/`,
            method: 'PUT',
            data: data
        });
    }

    reports(panelId, page = 1, perPage) {
        return this.$http({
            url: `${this._api}/panels/${panelId}/events/?page_size=${perPage}&page=${page}`,
            params: {page: page},
            method: 'GET'
        });
    }

    deletePicture(panelId, pictureId) {
        return this.$http({
            url: this._api + '/panels/' + panelId + '/pictures/' + pictureId + '/',
            method: 'DELETE'
        });
    }

    getPictures(panelId, page = 1) {
        return this.$http({
            url: `${this._api}/panels/${panelId}/pictures/`,
            params: {page: page},
            method: 'GET'
        });
    }

    getZonePictures(panelId, zoneId, page = 1,) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/zones/${zoneId}/pictures/`,
            params: {page: page},
            method: 'GET'
        });

    }

    takePicture(panelId, zoneId) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/zones/${zoneId}/pictures/`,
            method: 'POST'
        });
    }

    cancelTakePicture(panelId, zoneId) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/zones/${zoneId}/pictures/`,
            method: 'DELETE'
        });
    }

    removeFromAccount(mac) {
        return this.$http({
            url: this._api + '/panels/remove/' + mac + '/',
            method: 'DELETE'
        });
    }

    _getDectMeasurements(panelId, deviceTypeStr, deviceId, interfaceId, durationStr, offset) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/dect/measurements/${deviceTypeStr}/${deviceId}/
			interface/${interfaceId}/?duration=${durationStr}&offset=${offset}`,
            method: 'GET'
        });
    }

    getDectOutputMeasurements(panelId, outputId, interfaceId, durationStr, offset) {

        return this._getDectMeasurements(panelId, 'output', outputId, interfaceId, durationStr, offset);
    }

    getDectZoneMeasurements(panelId, zoneId, interfaceId, durationStr, offset) {
        return this._getDectMeasurements(panelId, 'zone', zoneId, interfaceId, durationStr, offset);
    }

    getConnectionMeasurements(panelId, deviceTypeStr, deviceId, interfaceId, durationStr, offset) {
        if(durationStr === 'hour') {
            durationStr = 'day';
        }
        return this.$http({
            url: `${this._api}/panels/${panelId}/measurements/${deviceTypeStr}/0/
			interface/32784/?duration=1${durationStr}&offset=${offset}`,
            method: 'GET'
        });
    }

    getGSMConnectionMeasurements(panelId, deviceId, interfaceId, durationStr, offset) {
        return this.getConnectionMeasurements(panelId, 'gsm', deviceId, interfaceId, durationStr, offset);
    }

    getWifiConnectionMeasurements(panelId, deviceId, interfaceId, durationStr, offset) {
        return this.getConnectionMeasurements(panelId, 'wifi', deviceId, interfaceId, durationStr, offset);
    }

    getDectKeypadMeasurements(panelId, zoneId, interfaceId, durationStr, offset) {

        return this._getDectMeasurements(panelId, 'keypad', zoneId, interfaceId, durationStr, offset);
    }

    _getDectLastMeasurements(panelId, deviceTypeStr, deviceId, interfaceId) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/dect/measurements/${deviceTypeStr}/${deviceId}/interface/${interfaceId}/`,
            method: 'GET'
        });
    }

    _getDeviceGenericStatisticsMeasurements(panelId, deviceTypeStr, decviceId, interfaceId, durationStr, offset) {
        return this.$http({
            url: `${this._api}/panels/${panelId}/measurements/${deviceTypeStr}/${decviceId}/
			interface/${interfaceId}/?duration=${durationStr}&offset=${offset}`,
            method: 'GET'
        });
    }

    getZoneGenericStatisticsMeasurements(panelId, zoneId, interfaceId, durationStr, offset) {
        return this._getDeviceGenericStatisticsMeasurements(panelId, 'zone', zoneId, interfaceId, durationStr, offset)
    }

    getOutputGenericStatisticsMeasurements(panelId, outputId, interfaceId, durationStr, offset) {
        return this._getDeviceGenericStatisticsMeasurements(panelId, 'output', outputId, interfaceId, durationStr, offset)
    }

    getKeypadGenericStatisticsMeasurements(panelId, keypadId, interfaceId, durationStr, offset) {
        return this._getDeviceGenericStatisticsMeasurements(panelId, 'keypad', keypadId, interfaceId, durationStr, offset)
    }

    getDectOutputLastMeasurements(panelId, outputId, interfaceId) {

        return this._getDectLastMeasurements(panelId, 'output', outputId, interfaceId);
    }

    getDectZoneLastMeasurements(panelId, zoneId, interfaceId) {

        return this._getDectLastMeasurements(panelId, 'zone', zoneId, interfaceId);
    }

    getDectKeypadLastMeasurements(panelId, keypadId, interfaceId) {

        return this._getDectLastMeasurements(panelId, 'keypad', keypadId, interfaceId);
    }

    getEmailNotification(panelId) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/notifications/`,
            method: 'GET'
        });
    }

    setEmailNotification(panelId, notificationId, emailAddress) {
        return this.$http({
            url: `${this._api}/panels/${panelId}/notifications/${notificationId}/`,
            method: 'PUT',
            data: {'key': emailAddress}
        });
    }

    addEmailNotification(panelId, emailAddress) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/notifications/`,
            method: 'POST',
            data: {'key': emailAddress}
        });
    }

    deleteEmailNotification(panelId, emailAddressId) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/notifications/${emailAddressId}/`,
            method: 'DELETE'
        });
    }

    getConnectionInfo(panelId) {

        return this.$http.get(this._api + '/panels/' + panelId + /connection/);
    }

    getModuleInfo(moduleName, panelId) {

        return this.$http.get(this._api + '/panels/' + panelId + /module/ + moduleName + '/info/');
    }

    getEthernetInfo(panelId) {

        return this.getModuleInfo('ethernet', panelId)
    }

    getGsmInfo(panelId) {

        return this.getModuleInfo('gsm', panelId)
    }

    getWifiInfo(panelId) {

        return this.getModuleInfo('wifi', panelId)
    }

    getRadioInfo(panelId) {

        return this.getModuleInfo('radio', panelId)
    }

    getPanelFullInfo(panelId) {
        return this.$http.get(this._api + '/panels/' + panelId + '/panel_info/');
    }

    addPanelUser(panelId, userObject, userCode) {
        return this.$http.post(this._api + '/panels/' + panelId + `/users/`, userObject, {
            headers: {
                'X-Crow-CP-User': userCode,
            }
        });
    }

    deletePanelUser(panelId, userId, userCode) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/users/${userId}/`,
            method: 'DELETE',
            headers: {
                'X-Crow-CP-User': userCode,
            }
        });
    }

    changePanelEmergencyPhone(panelId, phoneList, userCode) {
        return this.$http.put(this._api + '/panels/' + panelId + `/communications/dect/`, {'phone': phoneList}, {
            headers: {
                'X-Crow-CP-User': userCode,
            }
        });
    }

    changePanelPhone(panelId, phoneObject, userCode) {
        return this.$http.put(this._api + '/panels/' + panelId + `/report_channels/${phoneObject.id}/`, phoneObject, {
            headers: {
                'X-Crow-CP-User': userCode,
            }
        });
    }

    changePanelUser(panelId, userObject, userCode) {
        return this.$http.put(this._api + '/panels/' + panelId + `/users/${userObject.id}/`, userObject, {
            headers: {
                'X-Crow-CP-User': userCode,
            }
        });
    }

    changePanelKeypad(panelId, keypadObject, userCode) {
        return this.$http.put(this._api + '/panels/' + panelId + `/keypads/${keypadObject.id}/`, keypadObject, {
            headers: {
                'X-Crow-CP-User': userCode,
            }
        });
    }

    changePanelZone(panelId, zoneObject, userCode) {
        return this.$http.put(this._api + '/panels/' + panelId + `/zones/${zoneObject.id}/`, zoneObject, {
            headers: {
                'X-Crow-CP-User': userCode,
            }
        });
    }

    changePanelOutput(panelId, outputObject, userCode) {
        return this.$http.put(this._api + '/panels/' + panelId + `/outputs/${outputObject.id}/`, outputObject, {
            headers: {
                'X-Crow-CP-User': userCode,
            }
        });
    }

    changePanelArea(panelId, areaObject, userCode) {
        return this.$http.put(this._api + '/panels/' + panelId + `/areas/${areaObject.id}/`, areaObject, {
            headers: {
                'X-Crow-CP-User': userCode,
            }
        });
    }

    resetPanelConnection(panelId) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/connection/`,
            method: 'DELETE'
        }).then(r => {
            this.$state.go('main.panels')
        });
    }

    getEmergencyPhone(panelId) {
        return this.$http.get(`${this._api}/panels/${panelId}/communications/dect/`);
    }

    getInstallerMaintenanceAccessTime(panelId) {
        return this.$http.get(`${this._api}/panels/${panelId}/maintenance/`);
    }

    setInstallerMaintenanceForONeHourAccessTime(panelId) {
        return this.$http.post(`${this._api}/panels/${panelId}/maintenance/`);
    }

    setInstallerMaintenanceForEightHoursAccessTime(panelId) {
        return this.$http.post(`${this._api}/panels/${panelId}/maintenance/`, {requested_time: 28800});
    }

    deleteInstallerMaintenanceAccessTime(panelId) {
        return this.$http.delete(`${this._api}/panels/${panelId}/maintenance/`);
    }

    learnAccessTag(panelId, userId, userCode) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/users/${userId}/learn_access_tag/`,
            method: 'POST',
            headers: {
                'X-Crow-CP-User': userCode,
            }
        })
    }

    deleteAccessTag(panelId, userId, userCode) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/users/${userId}/learn_access_tag/`,
            method: 'DELETE',
            headers: {
                'X-Crow-CP-User': userCode,
            }
        })
    }

    getAccessTagLearnState(panelId) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/access_tags/learn_state/`,
            method: 'GET'
        })
    }

    stopAccessTagLearning(panelId, userCode) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/access_tags/learn_state/`,
            method: 'DELETE',
            headers: {
                'X-Crow-CP-User': userCode,
            }
        })
    }

    getScheduledTasksList(panelId) {
        return this.$http.get(`${this._api}/panels/${panelId}/schedules/`);
    }

    addScheduledTask(panelId, timeZone, daysOfWeek, hour, minute, action, params) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/schedules/`,
            data: {
                "timezone": timeZone,
                "days_of_week": daysOfWeek,
                "hour": hour,
                "minute": minute,
                "action": action,
                "params": params
            },
            method: 'POST'
        });
    }

    editScheduledTask(panelId, taskId, timeZone, daysOfWeek, hour, minute, action, params, disabled) {

        return this.$http({
            url: `${this._api}/panels/${panelId}/schedules/${taskId}/`,
            data: {
                "timezone": timeZone,
                "days_of_week": daysOfWeek,
                "hour": hour,
                "minute": minute,
                "action": action,
                "params": params,
                "disabled": disabled,
            },
            method: 'PATCH'
        });
    }

    getScheduledTask(panelId, taskId) {
        return this.$http.get(`${this._api}/panels/${panelId}/schedules/${taskId}/`);
    }

    deleteScheduledTask(panelId, taskId) {
        return this.$http.delete(`${this._api}/panels/${panelId}/schedules/${taskId}/`);
    }

    getPhoneNumbers(panelId) {
        return this.$http.get(`${this._api}/panels/${panelId}/report_channels/`);
    }

    isMoreThenOnePanel() {

        return this.panelsCounter > 1;
    }

    setPanelsCounter(numberOfPanels) {

        this.panelsCounter = numberOfPanels;
    }

    setHttpHeaders(remoteAccessPassword, userCode) {
        this.remoteAccessPassword = this.$http.defaults.headers.common['X-Crow-CP-Remote'] = remoteAccessPassword;
        this.userCode = this.$http.defaults.headers.common['X-Crow-CP-User'] = userCode;
    }

    resetRemoteAccessPassword() {
        this.remoteAccessPassword = this.$http.defaults.headers.common['X-Crow-CP-Remote'] = undefined;
    }

    resetUserCode() {
        this.userCode = this.$http.defaults.headers.common['X-Crow-CP-User'] = undefined;
    }

    resetHttpHeaders() {
        this.resetRemoteAccessPassword();
        this.resetUserCode();
    }

    saveRemoteAccessPasswordAndUserCode(userId, remoteAccessPassword, userCode, macAddress) {

        return this.$http({
            url: `${this._api}/panel_users/${userId}/`,
            method: 'PATCH',
            data: {
                'user_code': userCode,
                'control_panel': {
                    'mac': macAddress,
                    'remote_access_password': remoteAccessPassword,
                }
            }
        });
    }

    getRemoteAccessPassword() {
        return this.remoteAccessPassword;
    }

    getUserCode() {
        return this.userCode;
    }

}


/** WEBPACK FOOTER **
 ** ./src/services/api/api.panels.service.js
 **/